import FormattedMessage from 'I18n/components/FormattedMessage';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalOperation } from '../../types/ApprovalOperation';
import { ApprovalModalMessageI18nApprove } from '../i18n/ApprovalModalMessageI18n';
import { ApprovalTypes } from '../../types';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApprovalModalMessage = () => {
  const approval = useApprovalContext();
  const {
    currentOperation,
    assetName,
    approvalType
  } = approval.meta;
  switch (currentOperation) {
    case ApprovalOperation.APPROVE:
      return /*#__PURE__*/_jsx(ApprovalModalMessageI18nApprove, {});
    case ApprovalOperation.CANCEL:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalMessage.CANCEL",
        options: {
          assetName
        }
      });
    case ApprovalOperation.REQUEST:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalMessage.REQUEST",
        options: {
          assetName
        }
      });
    case ApprovalOperation.REJECT:
      if (approvalType === ApprovalTypes.DEAL) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.REJECT.DEAL",
          options: {
            assetName
          }
        });
      }
      if (approvalType === ApprovalTypes.QUOTE) {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "productApprovals.ApprovalModalMessage.REJECT.QUOTE",
          options: {
            assetName
          }
        });
      }
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.ApprovalModalMessage.REJECT.default",
        options: {
          assetName
        }
      });
    default:
      return null;
  }
};